import { render, staticRenderFns } from "./messages.vue?vue&type=template&id=4d25ba98&scoped=true"
import script from "./messages.vue?vue&type=script&lang=js"
export * from "./messages.vue?vue&type=script&lang=js"
import style0 from "./messages.vue?vue&type=style&index=0&id=4d25ba98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d25ba98",
  null
  
)

export default component.exports